<div class="ws-popup-header">
  <div>{{ title }}</div>

  <div class="actions">
    <button (click)="closeClicked()" mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<div class="ws-popup-content">
  <ng-container *ngComponentOutlet="dynamicComponent; injector: wsDialogInjector"></ng-container>
  <div class="ws-popup-footer">
    <span></span>
    <div class="actions-wrapper">
      <ws-button [callToActionType]="'tertiary'" (click)="closeClicked()" style="margin-right: 10px">{{ 'Cancel' |
        translate }}
      </ws-button>
      <ws-button [callToActionType]="'primary'" (click)="saveClicked()" type="submit">{{ 'Save' | translate
        }}</ws-button>
    </div>
  </div>
</div>